import script from "./PlanParticularDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanParticularDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PlanParticularDetailsPopup.vue?vue&type=style&index=0&id=273b55fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273b55fe"]])

export default __exports__